import React from 'react';
import AdSlot from './AdSlot';

/**
 * Full-width page band holding one ad slot from GET /api/ads?active_only=true.
 * Renders nothing while loading, or when the slot is missing, disabled or empty.
 */
export const AdvertisementSection = ({
  slotId,
  variant = 'banner',
  maxWidthClass = 'max-w-[1680px]',
  className = 'pt-2 pb-8 bg-transparent',
}) => <AdSlot slotId={slotId} variant={variant} container={{ className, maxWidthClass }} />;

export default AdvertisementSection;
